<template>
  <div v-if="maxPoints > 0"
    v-html="$translate('BonusProgram::Template.reachablePoints', { maxPoints: maxPoints })">
  </div>
</template>

<script>
export default {
  name: "ItemPoints",

  props: {
    template: {
      type: String,
      default: '#vue-item-points'
    },
    itemId: {
      type: Number,
      default: 0
    },
    isPreview: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      pointsPerCoin: 1
    }
  },

  computed: {
    variationTotalPrice() {
      return this.$store.getters[`${this.itemId}/variationTotalPrice`];
    },
    
    maxPoints() {
      if (this.isPreview) {
        return this.formatNumber(1000);
      }
      return this.formatNumber(
        Math.ceil(this.variationTotalPrice * this.pointsPerCoin),
      )
    }
  },

  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat('de-DE').format(
        number,
      )
    }
  }
};
</script>
